import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { BillingConceptFilter } from '../../model/billing/billing-concept-filter';

@Injectable({
  providedIn: 'root'
})
export class BillingConceptService {

  constructor( private dataService: DataService ) {
  }

  private readonly getBillingConceptFiltersEndPoint: string = '/billingConcept/getBillingConceptFilters/';

  async getBillingConceptFilters( ): Promise<BillingConceptFilter[]> {
    const params = { };
    return await this.dataService
                     .get<BillingConceptFilter[]>(this.getBillingConceptFiltersEndPoint, params)
                     .toPromise();
  }

}
